import { SxProps, Theme } from '@mui/material/styles';
import React, { ReactNode } from 'react';

export enum UnderlineTypeProps {
  Always = 'always',
  Hover = 'hover',
  None = 'none',
}

export interface LinkProps {
  children?: ReactNode;
  color?: string;
  /** Forwarded to the underlying MUI Link — useful for theme tokens like `v4.accent` that the `color` prop doesn't accept. */
  sx?: SxProps<Theme>;
  underline?: UnderlineTypeProps;
  href?: string;
  target?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}
